import React from 'react';
// @ts-ignore
import userAgent from 'lib/currentUserAgent';
import CoachingConstants from 'coaching/CoachingConstants';
import Columns2 from 'components/Columns2';
import Container from 'components/Container';
import Icon, { IconName } from 'components/Icon';
import Link from 'components/Link';
import Row from 'components/Row';
import Text from 'components/Text';
import CoachingHeading from 'coaching/components/CoachingHeading';

const resources = [
  {
    iconName: 'book',
    audience: 'Coaches',
    resourceName: 'Coaching handbook',
    description: 'Review our guides and policies around booking availability, payment, and more.',
    resourceUrl: CoachingConstants.COACH_HANDBOOK_URL,
    asHref: true,
  },
  {
    iconName: 'question-circle',
    audience: `Students & Parents`,
    resourceName: 'Customer help page',
    description:
      'Direct parents and students here to prepare for their session and to report issues.',
    resourceUrl: CoachingConstants.COACHING_HELP_ROUTE,
    asHref: false,
  },
];

export default function CoachingCoachHelpAdditionalResourcesSection() {
  const isDesktop = userAgent.isDesktop();
  const renderedResources = resources.map(props => {
    if (isDesktop) {
      return <ResourceColumn key={props.resourceName} {...props} />;
    }

    return (
      <Row size="xlarge">
        <ResourceColumn key={props.resourceName} {...props} isDesktop={false} />
      </Row>
    );
  });

  return (
    <Container>
      <CoachingHeading textSize="xlarge" size="xxxlarge" centerText>
        Additional Resources
      </CoachingHeading>
      {isDesktop ? <Columns2 divider>{renderedResources}</Columns2> : renderedResources}
    </Container>
  );
}

type ResourceColumnProps = {
  iconName: IconName;
  audience: string;
  resourceName: string;
  description: string;
  resourceUrl: string;
  asHref?: boolean;
  isDesktop?: boolean;
};

function ResourceColumn(props: ResourceColumnProps) {
  const {
    iconName,
    audience,
    resourceName,
    description,
    resourceUrl,
    asHref,
    isDesktop = true,
  } = props;
  const linkProps = {
    to: asHref ? undefined : resourceUrl,
    href: asHref ? resourceUrl : undefined,
    target: asHref ? '_blank' : undefined,
  };

  return (
    <React.Fragment>
      <Row size={isDesktop ? 'small' : 'xsmall'}>
        <Text color="koolaid" align="center">
          <Icon size="large" name={iconName} color="currentColor" />
        </Text>
      </Row>
      <Text size="small" align="center">
        {audience}
      </Text>
      <Row size="small">
        <Text size="xlarge" weight="semibold" align="center">
          {resourceName}
        </Text>
      </Row>
      <Row size={isDesktop ? 'large' : 'small'}>
        <Text color="graphite" size="medium" align="center">
          {description}
        </Text>
      </Row>
      <Text size="medium" weight="semibold" align="center">
        <Link color="koolaid" {...linkProps}>
          View resource
        </Link>
      </Text>
    </React.Fragment>
  );
}
